import { useSetPartnerLogic } from '@ecomm/partners-hooks'
import { getCustomerId } from '@ecomm/partners-utils'
import { usePromoBannerState } from '@ecomm/promotions-hooks'

export type PartnerPagePromoDataProps = {
  readonly partnerName: string
  readonly partnerGroup: string
  readonly pagePath: string
  readonly id: string | null
}

export function usePartnerPagePromoData({
  partnerName,
  partnerGroup,
  pagePath,
  id
}: PartnerPagePromoDataProps) {
  const { hasBanner, isPartnerBanner } = usePromoBannerState()
  const hasPartnerBanner = hasBanner && isPartnerBanner

  useSetPartnerLogic(
    partnerName,
    partnerGroup,
    pagePath,
    getCustomerId(partnerName, id)
  )

  return { hasPartnerBanner }
}
